import compact from 'lodash/compact';
import { deletedRsvpQuestionAnalytics } from '@bridebook/web/lib/rsvp/analytics/actions';
import { useWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import { useUpdateWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-update-wedding-rsvp';
import { useGetIsPopularRsvpQuestions } from '@bridebook/web/lib/rsvp/hooks/use-get-is-popular-rsvp-questions';
import { useUnifiedEvents } from '@bridebook/web/lib/events/use-unified-events';
import { useDispatch } from '@bridebook/web/lib/utils';
import { useEventOptionsWithHandlers } from '@bridebook/web/lib/rsvp/hooks/use-event-options-with-handlers';
import { useFormContext } from 'react-hook-form';
import { RsvpQuestionFormValues } from '@bridebook/web/lib/rsvp/types';

export const useDeleteQuestion = ({
  questionId,
  onBack,
}: {
  questionId?: string;
  onBack: () => void;
}) => {
  const dispatch = useDispatch();
  const { data: weddingRsvp } = useWeddingRsvp();
  const { mutateAsync: updateWeddingRsvpAsync } = useUpdateWeddingRsvp();
  const { unifiedEvents, isLoading: isUnifiedEventsLoading } = useUnifiedEvents();
  const isPopularRsvpQuestion = useGetIsPopularRsvpQuestions();
  const isNewEntry = !questionId || questionId === 'add';

  const { setValue, getValues } = useFormContext<RsvpQuestionFormValues>();

  const { eventOptions } = useEventOptionsWithHandlers({
    isLoading: isUnifiedEventsLoading,
    unifiedEvents,
    getValues,
    setValue,
  });
  const handleDelete = async () => {
    if (!weddingRsvp || isNewEntry) return;
    const rsvpToDelete = weddingRsvp.questions.find((q) => q.id === questionId);
    if (!rsvpToDelete) return;
    await updateWeddingRsvpAsync({
      ...weddingRsvp,
      questions: weddingRsvp.questions.filter((q) => q.id !== questionId),
    });
    const isList = rsvpToDelete.type === 'list';

    const isPopularQuestion = isPopularRsvpQuestion(rsvpToDelete);
    const eventsNames = compact(
      rsvpToDelete.events.map((e) => unifiedEvents.find((ue) => e === ue.id)?.name),
    );
    dispatch(
      deletedRsvpQuestionAnalytics({
        type: isPopularQuestion ? 'popular' : 'custom',
        question: rsvpToDelete.question,
        events: rsvpToDelete.events.length === eventOptions.length ? 'allEvents' : 'selectEvents',
        eventsList: eventsNames,
        ...(isList
          ? {
              answerType: 'selection',
              selectionList: rsvpToDelete.options,
            }
          : {
              answerType: rsvpToDelete.type === 'boolean' ? 'yesNo' : 'longText',
            }),
      }),
    );
    onBack();
  };
  return handleDelete;
};
